import React, { useRef, useEffect } from 'react';
import { CustomAppLayout, Navigation, Notifications } from '../../commons/common-components';
import { useNavigation } from '../../hooks/useNavigation';
import BreadcrumbGroup from '@amzn/awsui-components-react/polaris/breadcrumb-group';
import { navigationBreadcrumbs } from '../../pages/uploadfilescommon/breadcrumbs';
import FeedbackModal, { FeedbackModalRef } from '../../components/FeedbackModal';

interface AppLayoutProps {
  content: React.ReactNode;
  toolsHide?: boolean;
  breadcrumbs?: {
    text: string;
    href: string;
  }[];
  onFeedbackClick?: () => void;
}

const Breadcrumbs: React.FC<{ items: { text: string; href: string; }[] }> = ({ items }) => (
  <BreadcrumbGroup items={items} expandAriaLabel="Show path" ariaLabel="Breadcrumbs" />
);

export const AppLayout: React.FC<AppLayoutProps> = ({ 
  content, 
  toolsHide = true, 
  breadcrumbs = navigationBreadcrumbs,
  onFeedbackClick 
}) => {
  const { navigationOpen, setNavigationOpen } = useNavigation();
  const feedbackModalRef = useRef<FeedbackModalRef>(null);

  return (
    <>
      <CustomAppLayout
        disableContentPaddings={true}
        content={content}
        navigation={<Navigation activeHref="#/" />}
        navigationOpen={navigationOpen}
        onNavigationChange={setNavigationOpen}
        toolsHide={toolsHide}
        notifications={<Notifications />}
        breadcrumbs={<Breadcrumbs items={breadcrumbs} />}
      />
      {/* We no longer need the local FeedbackModal since feedback is only in top navigation */}
    </>
  );
};
